import { Page, PageHeader } from 'components';
import { Card, Dialog, Grid, Box } from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import React, { useState } from 'react';
import { EventsFilter, EventsTable } from './components';
import EventDetails from './components/EventDetails';

import { useLocation } from 'react-router-dom';
import { SearchFilter } from 'components/Events';

const useStyles = makeStyles((theme) => ({
  root: {
    padding: theme.spacing(2),
    width: '100%',
    height: '100%',
    minHeight: '100%',
    flex: 1,
  },
  eventfilter: {
    width: '100%',
  },
  header: {
    marginBottom: theme.spacing(2),
  },
}));

const EventsPageDesktop = () => {
  const classes = useStyles();

  const [activeEvent, setSelectedEvent] = useState({});
  const [filterIsOpen, setFilterIsOpen] = useState(false);
  const location = useLocation();

  // If we're redirected here, we can use the redirectData to set the filters
  const [redirectData] = useState(location.state?.redirectData ? location.state.redirectData : undefined);

  if (redirectData) {
    location.state.redirectData = undefined;
  }
  const [redirectEvents, setRedirectEvents] = useState(!!redirectData);

  const [showDetails, setShowDetails] = useState(false);
  const [selectedId, setSelectedId] = useState('');

  const handleHide = () => {
    setSelectedEvent({});
    setSelectedId('');
    setShowDetails(false);
  };

  const toggleFilter = () => {
    setFilterIsOpen(!filterIsOpen);
  };

  return (
    <Page>
      <Box>
        <PageHeader title="events" className={classes.header}></PageHeader>
        <Grid container spacing={2} alignItems="flex-start">
          <Grid container item sm={8} md={10} spacing={2}>
            <Grid item sm={12}>
              <SearchFilter />
            </Grid>
            <Grid item sm={12}>
              <EventsTable
                redirectData={{ redirectData: redirectData, redirectEvents: redirectEvents }}
                setSelectedEvent={setSelectedEvent}
                selectedEvent={activeEvent}
                setShowDetails={setShowDetails}
                selectedId={selectedId}
                setSelectedId={setSelectedId}
              />
            </Grid>
          </Grid>
          <Grid item sm={4} md={2}>
            <Card>
              <EventsFilter isOpen={filterIsOpen} toggleFilter={toggleFilter} setRedirectEvents={setRedirectEvents} />
            </Card>
          </Grid>
        </Grid>
        <Dialog
          disableEnforceFocus
          style={{ pointerEvents: 'none' }}
          PaperProps={{ style: { pointerEvents: 'auto' } }}
          open={showDetails}
          hideBackdrop
          onClose={() => {}}
        >
          <div>
            {!!showDetails && (
              <EventDetails setSelectedId={setSelectedId} selectedEvent={activeEvent} hide={() => handleHide()} />
            )}
          </div>
        </Dialog>
      </Box>
    </Page>
  );
};

export default EventsPageDesktop;
